import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import GuidaInstalla from '../components/cliente/GuidaInstalla';
import { contesto, valida } from '../i18n';
import { comeInstallare, installaConInvito, installataAdesso, quandoCambia } from '../utils/installa';
import '../components/cliente/installa.css';

// https://mkclient.it/installa — la pagina che arriva su WhatsApp e nelle email.
//
// Deve funzionare per chi NON è collegato: è la prima cosa che il cliente apre, spesso prima ancora di avere la
// password. Per questo sta fra le rotte pubbliche (App.js) e la lingua non la prende dal profilo — che non c'è —
// ma dall'indirizzo (`?lingua=ru`, ce la mette lo staff quando manda il link) e in mancanza dal browser.
//
// Il telefono lo riconosce da sé: chi la apre da un iPhone vede i passi di Safari, chi la apre da Android vede
// quelli di Chrome, e se Chrome offre l'installazione vera c'è anche il bottone che la apre.

// La lingua del browser ("ru-RU" → "ru"), che è il ripiego migliore quando il link arriva senza `?lingua=`
const linguaDelBrowser = () => {
  try {
    return valida(String(navigator.language || '').slice(0, 2).toLowerCase());
  } catch {
    return 'it';
  }
};

const Installa = () => {
  const [parametri] = useSearchParams();
  const lingua = valida(parametri.get('lingua') || linguaDelBrowser());
  const { t } = contesto(lingua);
  const [attesa, setAttesa] = useState(false);
  const [, ridisegna] = useState(0);
  useEffect(() => quandoCambia(() => ridisegna((n) => n + 1)), []);

  useEffect(() => { document.title = `MK Client — ${t('installa.voce')}`; }, [t]);

  const installata = installataAdesso();

  const installa = async () => {
    setAttesa(true);
    await installaConInvito();
    setAttesa(false);
  };

  return (
    <div className="mk-installa" style={{ position: 'static', minHeight: '100vh' }} data-testid="pagina-installa"
      lang={lingua}>
      <div className="dentro">
        <div className="testa">
          <div>
            <h2>{t('installa.pagina.titolo')}</h2>
            <p>{t('installa.pagina.sotto')} {!installata && t('installa.guida.sotto')}</p>
          </div>
        </div>

        {installata ? (
          <p className="chiusura" data-testid="installa-gia">{t('installa.gia_installata')}</p>
        ) : (
          <>
            {/* Android con Chrome che la offre: un tocco e basta, la guida resta sotto per chi preferisce vederla */}
            {comeInstallare() === 'invito' && (
              <div className="bottoni" style={{ marginBottom: '1.2rem' }}>
                <button type="button" className="b p" onClick={installa} disabled={attesa} data-testid="installa-avvia">
                  {t('installa.installa')}
                </button>
              </div>
            )}
            <GuidaInstalla lingua={lingua} comePagina />
          </>
        )}

        <div className="bottoni">
          <Link className="b" to="/login">{t('installa.pagina.entra')}</Link>
        </div>
      </div>
    </div>
  );
};

export default Installa;
